<template>
  <div class="filter-container">
    <filter-title
      :title="title"
      :show-settings-button="false"
      @filter-reset="resetFilter"
      @toggle-settings="showSettings = !showSettings"
      @toggle-description="showDescription = !showDescription"
    ></filter-title>
    
    <filter-description
      :title="title"
      :show="showDescription"
      :description="options.description" class="mb-4"
    />
    <filter-settings    
      :show="true"  
      :items="filterMode.options"
      :value="filterMode.value"
      @setting-changed="filterModeChanged"
      :filled="true"
    />
    <v-row class="mb-0">
      <v-col class="pr-0 pt-0 pb-0">
        <v-autocomplete
          @input="onSelectedYearRangeChange"
          v-model="fromYearOptions.value"
          :items="fromYearOptions.options"
          filled
          dense
          hide-details="auto"
          label="Fra år"
        ></v-autocomplete>
      </v-col>
      <v-col class="pt-0 pb-0">
        <v-autocomplete
          @input="onSelectedYearRangeChange"
          v-model="toYearOptions.value"
          :items="toYearOptions.options"
          filled
          dense
          hide-details="auto"
          label="Til år"
        ></v-autocomplete>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { FilterTitle } from "@/components/index";
import FilterDescription from "./FilterDescription";
import FilterSettings from "./FilterSettings";
import { mapActions } from "vuex";
import { getQueryStringForYearRange } from "./utils.js"

export default {
  name: "FilterDates",
  components: { FilterTitle, FilterDescription, FilterSettings },
  data () {
    return {
      fromYearOptions: {
        value: "",
        options: []
      },
      toYearOptions: {
        value: "",
        options: []
      },
      filterMode: {
        value: {
          id: "parts",
          name: "Dekker deler av tidsrommet"
        },
        options: [
          {
            id: "full",
            name: "Dekker hele tidsrommet"
          },
          {
            id: "parts",
            name: "Dekker deler av tidsrommet"
          }
        ]
      },
      showDescription: false,
      showSettings: false
    };
  },
  computed: {
    fromYear: {
      get () {
        return this.$store.state.fromYear;
      },
      set (newValue) {
        return this.$store.dispatch("setFromYear", newValue);
      }
    },
    toYear: {
      get () {
        return this.$store.state.toYear
      },
      set (newValue) {
        return this.$store.dispatch('setToYear', newValue)
      }
    },
    yearFilterMode: {
      get () {
        return this.$store.state.yearFilterMode
      },
      set (newValue) {
        return this.$store.dispatch('setYearFilterMode', newValue)
      }
    }
  },
  props: {
    title: String,
    options: Object,
    parameter: String
  },
  methods: {
    ...mapActions(["setChartDateRange", "setFilterValue"]),
    onSelectedYearRangeChange: function () {
      this.generateYearValues();
      this.updateFilter(this.value);
    },
    filterModeChanged: function (newValue) {
      this.filterMode.value = newValue;
      this.yearFilterMode = newValue;
      this.updateFilter();
    },
    updateFilter: function () {
      if (this.fromYearOptions.value !== '' && this.toYearOptions.value !== '') {
        this.fromYear = this.fromYearOptions.value;
        this.toYear = this.toYearOptions.value;
        let onlyIncludeTimeseriesThatCoverFullYearRange = this.filterMode.value.id === 'full';

        let queryString = getQueryStringForYearRange(this.fromYear, this.toYear, onlyIncludeTimeseriesThatCoverFullYearRange);

        this.setFilterValue({
          filterFieldName: this.parameter,
          filterQueryString: queryString
        });

        this.setChartDateRange({
          start: new Date(this.fromYearOptions.value, 0, 1),
          end: new Date(this.toYearOptions.value, 11, 31),
        })
      }
    },
    generateYearValues: function () {
      this.toYearOptions.options = [];
      this.fromYearOptions.options = [];
      for (let i = 1846; i <= new Date().getFullYear(); i++) {
        if (this.toYearOptions.value === "" || i <= this.toYearOptions.value) {
          this.fromYearOptions.options.push(i);
        }
        if (
          this.fromYearOptions.value === "" ||
          i >= this.fromYearOptions.value
        ) {
          this.toYearOptions.options.push(i);
        }
      }
      this.toYearOptions.options = this.toYearOptions.options.reverse();
      this.fromYearOptions.options = this.fromYearOptions.options.reverse();

    },
    resetFilter: function () {
      this.fromYear = null;
      this.toYear = null;
      this.toYearOptions.value = "";
      this.fromYearOptions.value = "";
      this.generateYearValues();
      this.setFilterValue({
        filterFieldName: this.parameter,
        filterQueryString: null
      });
      this.setChartDateRange({
        start: new Date(new Date().setMonth(new Date().getMonth() - 2)),
        end: new Date()
      })
    }
  },
  created: function () {
    this.generateYearValues();
    this.$eventHub.$on("reset-all-filters", this.resetFilter);
  }
};
</script>

<style>
</style>

